module.exports = __webpack_public_path__ + "static/media/1.CP-18.d7fcc494.webp";